<template>
  <JoszakiPage :page-name="pageName" class="ProfessionsLandingPage">
    <JoszakiHeading>
      {{ $t("professionsLandingPage.pageTitle") }}
    </JoszakiHeading>
    <section
      v-for="(professionGroup, index) in professionGroupsWithChildren"
      :id="professionGroup.seoName"
      :key="index"
    >
      <JoszakiHeading :level="2">
        {{ professionGroup.name }}
      </JoszakiHeading>
      <template v-if="professionsByGroupId[professionGroup.id]">
        <NuxtLink
          v-for="(profession, idx) in professionsByGroupId[professionGroup.id]"
          :key="idx"
          :to="
            localePath({
              name: 'professionPage',
              params: { profession: profession.seoName },
            })
          "
        >
          {{ profession.name }}
          {{
            idx !== professionsByGroupId[professionGroup.id].length - 1
              ? ", "
              : ""
          }}
        </NuxtLink>
      </template>
    </section>
  </JoszakiPage>
</template>

<router>
{
name: 'professionsLandingPage'
}
</router>

<script>
import { useContext, useFetch, computed } from "@nuxtjs/composition-api";
import JoszakiPage from "~/components/_refactored/common/JoszakiPage.vue";
import { EVENT_PAGE_NAMES } from "~/data/pageNames";
import { useLazyStore } from "~/stores/lazy";

export default {
  name: "ProfessionsLandingPage",
  components: {
    JoszakiPage,
  },
  layout: "DefaultLayout",
  setup() {
    const { store } = useContext();
    const lazyStore = useLazyStore();
    const professionGroups = store.getters["data/professionGroups"];

    useFetch(async () => {
      await lazyStore.loadProfessions();
    });

    const professionsByGroupId = computed(() => lazyStore.professionsByGroupId);
    const professionsCount = computed(() => lazyStore.professionsCount);

    return {
      pageName: EVENT_PAGE_NAMES.PROFESSIONS_LANDING_PAGE,
      professionsCount,
      professionGroups,
      professionsByGroupId,
    };
  },
  head() {
    return {
      title: this.$t("professionsLandingPage.headTitle"),
      meta: [
        {
          hid: "og:title",
          property: "og:title",
          content: this.$t("professionsLandingPage.headTitle"),
        },
        {
          hid: "og:url",
          property: "og:url",
          content: `${this.$helpers.topDomain}${this.$route.fullPath}`,
        },
        {
          hid: "og:image",
          property: "og:image",
          content: "/joszaki-head.png",
        },
        {
          hid: "description",
          name: "description",
          content: this.$t("professionsLandingPage.headDescription", {
            professionCount: this.professionsCount,
          }),
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.$t("professionsLandingPage.headDescription", {
            professionCount: this.professionsCount,
          }),
        },
      ],
      link: [
        {
          rel: "canonical",
          href: `${this.$helpers.topDomain}${this.$route.path}`,
        },
      ],
    };
  },
  computed: {
    professionGroupsWithChildren() {
      return this.professionGroups.filter(
        (group) => this.professionsByGroupId[group.id]?.length
      );
    },
  },
};
</script>
